var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.$route.name === 'Login')?_c('router-view'):_vm._e(),(this.$route.name !== 'Login')?_c('div',[_c('router-view'),_c('router-view',{ref:"footer",attrs:{"name":"footer"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }